export default __webpack_public_path__ + "static/card-2-14f5a82f15d998c025b24b69d759c15c.png";